module.exports = __webpack_public_path__ + "static/img/settingSuccess.5c1c464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/settingSuccess.jpg
// module id = 03ZO
// module chunks = 2